export const activityFilters = [
    {
        id: 'action',
        type: 'list',
        label: 'Action',
    },
    {
        id: 'userId',
        type: 'list',
        label: 'User Id',
    },
    {
        id: 'collectionName',
        type: 'list',
        label: 'Collection Name',
    },
    {
        id: 'workspaceId',
        type: 'list',
        label: 'Workspace ID',
    },
    {
        id: 'createdAt',
        type: 'date',
        label: 'Activity Date',
    },
];

export const activityBetaFilters = [
    {
        id: 'action',
        type: 'list',
        label: 'Action',
    },
    {
        id: 'collectionName',
        type: 'list',
        label: 'Collection Name',
    },
    {
        id: 'workspaceId',
        type: 'list',
        label: 'Workspace ID',
    },
    {
        id: 'createdAt',
        type: 'date',
        label: 'Activity Date',
    },
];
